/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-select-route[_ngcontent-%COMP%]{background-image:url(/assets/map.png);background-position:center;background-repeat:no-repeat;background-size:cover;height:100%}"];
export { styles as styles };
